import { initFacebookPixel,trackFacebookEvent } from '../utils/fbPixel/FacebookPixel';
import { env } from '../utils/env/config';

export const setFacebookPixel = () => {
  const { pixel } = env;
  if (!pixel) {
    console.log(`##### PLEASE CONFIG FaceBook Pixel ####`);
    return;
  }
    initFacebookPixel(pixel);

    return {
      event: (eventName, params) => trackFacebookEvent(eventName, params)
    };
};
